export default __webpack_public_path__ + "static/ami-logo-b6fa3b044f59e3e32768c9b591882907.png";